module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_gift_badge-7aaaa9599ee29834af3fa34ad53860b1.svg";